export default __webpack_public_path__ + "static/media/tms-portabella.a9c55042.webp";